// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v2DT","top":"styles_top__uL6G7"};